import React, { useState } from 'react';
import { Button, MenuItem } from 'react-bootstrap';
import axios from 'axios';

import routes from 'app/routes';

export default function InvoiceForecastReportButton() {
  const [loading, setLoading] = useState(false);

  const sendReport = () => {
    setLoading(true);

    axios
      .get(routes.api.enterprises.invoice_forecast_report)
      .then((_resp) => {
        swal({
          title: '',
          text: 'Invoice Forecast Report will be updated soon. Please, open Google Sheet and check the update in a couple of minutes.',
        });
        setLoading(false);
      });
  };

  return (
    <MenuItem
      onClick={sendReport}
    >
      Invoice Forecast Report
    </MenuItem>
  );
}
